import { Box } from '@mui/material';
import { useEffect } from 'react';
import { SnakeLoader } from '../../../core/loader/SnakeLoader';

export const FacebookCallback = () => {
  const url = new URL(window.location.href);

  useEffect(() => {
    const code = url.searchParams.get('code') || '';
    const state = url.searchParams.get('state')?.toLowerCase();

    if (!code) return;

    // ✅ FRONTEND decides navigation
    if (state === 'facebook-settings') {
      window.location.href = `/integrations/facebook-settings?code=${code}`;
    } else {
      window.location.href = `/reports/social-media-insight?code=${code}&state=Facebook`;
    }
  }, []);

  return (
    <Box sx={{
      backgroundColor: '#F8FAFC',
      minHeight: '100vh',
      padding: '32px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '16px',
    }} >
      <SnakeLoader size='1rem' bg='#11783C' distance='0.3rem' />
      <Box sx={{ fontSize: '16px', color: '#555', textAlign: 'center' }}>
        {url.searchParams.get('code') ? 'Connecting your Facebook account...' : 'Loading...'}
      </Box>
    </Box>
  );
};